import { Shift } from "../../../../../../models";
import { Filter } from "../../../common";
import { DataAPI_Base } from "../base";

const FOUR_MONTHS_MS = 4 * 30 * 24 * 60 * 60 * 1000;

export class ShiftsAPI extends DataAPI_Base<Shift> {
	constructor() {
		super("shifts", Shift);
	}

	public async byRobotName(robotName: string): Promise<Shift[]> {
		const cutoff = new Date(Date.now() - FOUR_MONTHS_MS).toISOString();
		const filter: Filter<Shift> = {
			type: "AND",
			fields: {
				robotId: robotName,
				startDate: { operator: ">=", value: cutoff },
			},
		};
		const shifts = await this.get.byFilter(filter);
		return shifts.sort((a, b) => (b.startDate?.getTime() ?? 0) - (a.startDate?.getTime() ?? 0));
	}
}
